import {useEffect} from 'react'

declare global {
  interface Window {
    astroData: {
      dfpData: {
        isDfp: boolean
      }
    }
  }
}

interface Props {
  isAdEnabled: boolean
}

const useSendAdDataToGameSDK = ({isAdEnabled}: Props) => {
  // astroData variable is added since games SDK depends on this value to determine
  // if rewarded ads can be shown or not for a publisher
  useEffect(() => {
    window.astroData = {
      dfpData: {
        isDfp: isAdEnabled,
      },
    }
  }, [isAdEnabled])
}

export default useSendAdDataToGameSDK
